import React from 'react';
import apps from 'Settings/apps';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ExploreCards from 'Components/ExploreCards';
import TopicCard from 'Containers/TopicCard';

const getAppTopics = app => {
  const topics = [];
  Object.keys(app.deepLinks).map(id => {
    topics.push(
      <TopicCard
        modelSlug={app.slug}
        topicSlug={id}
        topic={app.deepLinks[id]}
        key={`TopicCard-${id}`}
      />
    );
  });
  return topics;
};

class ExploreTopicsPage extends React.Component {
  render() {
    const selectedApps = [
      apps['human-body'],
      apps['simple-machines'],
      apps['coral-reef'],
    ];
    return (
      <main className="Page__content">
        <ExploreCards
          type="topic"
          groups={selectedApps.map(app => {
            return {
              title: (
                <ConnectedFormattedMessage id={`model.${app.slug}.title`} />
              ),
              items: getAppTopics(app),
            };
          })}
        />
      </main>
    );
  }
}

export default ExploreTopicsPage;
